module.exports = __webpack_public_path__ + "img/note-img2.2fccbf12.png";